import { render, staticRenderFns } from "./DropdownCustom.vue?vue&type=template&id=85856e06&scoped=true&"
import script from "./DropdownCustom.vue?vue&type=script&lang=js&"
export * from "./DropdownCustom.vue?vue&type=script&lang=js&"
import style0 from "./DropdownCustom.vue?vue&type=style&index=0&id=85856e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85856e06",
  null
  
)

export default component.exports